<!-- eslint-disable vue/multi-word-component-names -->
<script>
import AppBox from '@/components/app/box.vue';
import AppTitleHeader from '@/components/app/TitleHeader.vue';
import AppConversation from '@/components/app/conversation.vue';
export default {
  data() {
    return {
      stomach: require('@/assets/images/stomach.png'),
    };
  },
  components: {
    AppBox,
    AppTitleHeader,
    AppConversation,
  },
  props: {
    hadHeartMonitoring: {
      type: String,
      default: '-',
    },
    heartRhythmTitle: {
      type: String,
      default: '-',
    },
    heartSoundTitle: {
      type: String,
      default: '-',
    },

    skinTurgorTitle: {
      type: String,
      default: '-',
    },
    skinTemperature: {
      type: String,
      default: '-',
    },
    skinExaminationTitle: {
      type: String,
      default: '-',
    },
    hasNystagmusTitle: {
      type: String,
      default: '-',
    },
    hasEyeDeviationTitle: {
      type: String,
      default: '-',
    },
    pulseQualityTitle: {
      type: String,
      default: '-',
    },
    pulseRhythmTitle: {
      type: String,
      default: '-',
    },
    rightHandStrength: {
      type: String,
      default: '-',
    },
    leftHandStrength: {
      type: String,
      default: '-',
    },
    rightLegStrength: {
      type: String,
      default: '-',
    },
    leftLegStrength: {
      type: String,
      default: '-',
    },
    patientRespiratorySoundDetailsList: {
      type: Array,
      default: () => [],
    },
    patientPupilExaminationsList: {
      type: Array,
      default: () => [],
    },
    patientParturitionDetail: {
      type: Object,
      default: null,
    },
    patientAbdominal: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    parturitionTiming: function () {
      return this.patientParturitionDetail?.beforeCodeArrival
        ? 'قبل از رسیدن تکنسین'
        : 'بعد از رسیدن تکنسین';
    },
  },
};
</script>
<template>
  <v-row class="pa-4">
    <v-col cols="6">
      <app-title-header title="قلب و عروق" />
      <app-box outlined class="flex flex-col gap-2 mt-4">
        <app-conversation :between="true" question="مانیتورینگ قلبی" :answer="hadHeartMonitoring" />
        <app-conversation :between="true" question="ریتم قلب" :answer="heartRhythmTitle" />
        <app-conversation :between="true" question="سمع قلب" :answer="heartSoundTitle" />
      </app-box>
    </v-col>
    <v-col cols="6">
      <app-title-header title="پوست" />
      <app-box outlined class="flex flex-col gap-2 mt-4">
        <app-conversation :between="true" question="تورگور پوستی" :answer="skinTurgorTitle" />
        <app-conversation :between="true" question="دمای پوست" :answer="skinTemperature" />
        <app-conversation :between="true" question="وضعیت پوست" :answer="skinExaminationTitle" />
      </app-box>
    </v-col>
    <v-col cols="6">
      <app-title-header title="چشم" />
      <app-box outlined class="flex flex-col gap-2 mt-4">
        <app-conversation :between="true" question="نیستاگموس" :answer="hasNystagmusTitle" />
        <app-conversation :between="true" question="انحراف" :answer="hasEyeDeviationTitle" />
      </app-box>
    </v-col>
    <v-col cols="6">
      <app-title-header title="نبض" />
      <app-box outlined class="flex flex-col gap-2 mt-4">
        <app-conversation :between="true" question="کیفیت نبض" :answer="pulseQualityTitle" />
        <app-conversation :between="true" question="ریتم نبض" :answer="pulseRhythmTitle" />
      </app-box>
    </v-col>
    <v-col cols="12">
      <app-title-header title="بررسی قدرت عضلانی عضلات (MT)" />
      <app-box outlined class="flex-gap-2 justify-between mt-4">
        <div class="flex-grow">
          <app-conversation :between="true" question="دست راست" :answer="rightHandStrength" class="mb-2" />
          <app-conversation :between="true" question="دست چپ" :answer="leftHandStrength" />
        </div>
        <div class="flex-grow">
          <app-conversation :between="true" question="پای راست" :answer="rightLegStrength" class="mb-2" />
          <app-conversation :between="true" question="پای چپ" :answer="leftLegStrength" />
        </div>
      </app-box>
    </v-col>
    <!-- pergenent -->
    <v-col cols="12" v-if="patientParturitionDetail">
      <app-title-header title="زایمان" />
      <app-box outlined class="mt-2">
        <v-row no-gutters>
          <v-col class="flex gap-2 flex-col pr-2">
            <app-conversation :between="true" question="ساعت زایمان" answer="" />
            <app-conversation :between="true" question="چندقلویی" :answer="patientParturitionDetail?.isMultiple" />
            <app-conversation :between="true" question="نمای زایمان" answer="" />
            <app-conversation :between="true" question="آپگار" answer="" />
            <app-conversation question="چندمین بارداری" :between="true"
              :answer="patientParturitionDetail?.numberOfParturition" />
          </v-col>
          <v-col class="flex gap-2 flex-col">
            <app-conversation question="زمان زایمان" :between="true" :answer="parturitionTiming" />
            <app-conversation :between="true" question="جنس نوزاد" answer="" />
            <app-conversation :between="true" question="خروج جفت" answer="" />
            <app-conversation :between="true" question="سن بارداری" answer-postfix="سال"
              :answer="patientParturitionDetail?.pregnancyAge" />
          </v-col>
        </v-row>
      </app-box>
    </v-col>
    <!-- end pergnent -->
    <v-col v-if="patientRespiratorySoundDetailsList?.length" cols="3">
      <app-title-header title="ریه" />
      <app-box outlined class="mt-4 pa-2">
        <v-row no-gutters>
          <v-col cols="4" class="text-center">سمع ریه</v-col>
          <v-col cols="4"></v-col>
          <v-col cols="4" class="text-center">کاهش صدا</v-col>
        </v-row>
        <v-row no-gutters class="py-2">
          <div class="row-seperator"></div>
        </v-row>
        <v-row no-gutters>
          <v-col cols="4" class="text-center">R</v-col>
          <v-col cols="4" class="text-center">صدا</v-col>
          <v-col cols="4" class="text-center">L</v-col>
        </v-row>
        <v-row no-gutters v-for="{ id, title, left, right } in patientRespiratorySoundDetailsList" :key="id"
          class="items-center py-1">
          <v-col cols="4" class="text-center">
            <v-switch readonly dense hide-details color="lightColor" :input-value="right"
              class="mt-0 switch"></v-switch>
          </v-col>
          <v-col cols="4" class="text-center">{{ title }}</v-col>
          <v-col cols="4" class="text-center">
            <v-switch readonly hide-details dense color="lightColor" :input-value="left" class="mt-0 switch"></v-switch>
          </v-col>
        </v-row>
      </app-box>
    </v-col>
    <v-col cols="6">
      <app-title-header title="شکم" />
      <app-box outlined height="234px" max-height="240px" class="mt-4 flex flex-col pa-2">
        <v-row no-gutters>
          <v-col cols="6" class="flex flex-col pl-1">
            <v-img :src="stomach" fill height="140"></v-img>
          </v-col>
          <v-col cols="6" class="flex gap-2 flex-col">
            <app-box v-for="{ id, title, partNumber } in patientAbdominal" :key="id" class="pa-1">
              <app-conversation :gap="2" :question="partNumber" :answer="title" question-class="flex-grow"
                answer-class="flex-grow" />
            </app-box>
          </v-col>
        </v-row>
      </app-box>
    </v-col>
    <v-col v-if="patientPupilExaminationsList?.length" cols="3">
      <app-title-header title="مردمک" />
      <app-box outlined height="234px" class="mt-4 flex flex-col pa-2">
        <v-row no-gutters>
          <v-col cols="4" class="text-center">R</v-col>
          <v-col cols="4" class="text-center">وضعیت</v-col>
          <v-col cols="4" class="text-center">L</v-col>
        </v-row>
        <v-row no-gutters v-for="{ id, title, left, right } in patientPupilExaminationsList" :key="id"
          class="items-center py-1">
          <v-col cols="4" class="text-center">
            <v-switch readonly dense hide-details color="lightColor" :input-value="right"
              class="mt-0 switch"></v-switch>
          </v-col>
          <v-col cols="4" class="text-center">{{ title }}</v-col>
          <v-col cols="4" class="text-center">
            <v-switch readonly hide-details dense color="lightColor" :input-value="left" class="mt-0 switch"></v-switch>
          </v-col>
        </v-row>
      </app-box>
    </v-col>
  </v-row>
</template>
<style lang="scss">
.switch {
  .v-input__slot {
    justify-content: center !important;
  }
}
</style>
<style lang="scss" scoped>
.row-seperator {
  flex: 1;
  height: 1px;
  background-color: #21212133;
}
</style>
